import roles from "./roles"
import tokenStatus from "./tokenStatus"
import serverResponses from "./serverResponseKeyMessage"

// ----------------------------------------------------------------------------

export const ROLES = roles
export const TOKEN_STATUS = tokenStatus
export const BACKEND_RESPONSES_MESSAGES = serverResponses
